import { render, staticRenderFns } from "./ApfDocumentChecklist.vue?vue&type=template&id=f9da5624"
import script from "./ApfDocumentChecklist.vue?vue&type=script&lang=js"
export * from "./ApfDocumentChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports